import FocusLock from "react-focus-lock";
import clsx from "clsx";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { AuthenticatorIcon, MailIcon, SmartphoneIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  currMethod: TfaMethod | null;
  onChangeMethod: (method: TfaMethod) => void;
  onSubmit: () => void;
  enableMethods: TfaMethod[];
};

const RESET_METHODS = [
  {
    type: TfaMethod.AUTHENTICATOR,
    icon: AuthenticatorIcon,
    title: "Authenticator",
    description: "Сброс через Authentificator",
  },
  {
    type: TfaMethod.EMAIL,
    icon: MailIcon,
    title: "E-mail",
    description: "Сброс через почту",
  },
  // {
  //   type: TfaMethod.TELEGRAM,
  //   icon: "telegram",
  //   title: "Telegram",
  //   description: "Восстановить доступ через Telegram",
  // },
  {
    type: TfaMethod.SMS,
    icon: SmartphoneIcon,
    title: "SMS",
    description: "Сброс через SMS",
  },
];

export default function AuthResetPassword({
  currMethod,
  onSubmit,
  onChangeMethod,
  enableMethods,
}: Props) {
  return (
    <FocusLock className="contents">
      <div className="gap-3 grow flex flex-col">
        <div>Выберите способ восстановления:</div>
        {RESET_METHODS.map((method) => (
          <Button
            key={method.type}
            variant={currMethod === method.type ? "solid-surface-gradient" : "soft"}
            color={currMethod === method.type ? "accent" : "gray"}
            className={clsx(
              "justify-start px-5 gap-5 text-left h-20 normal-case text-base font-medium",
              enableMethods.includes(method.type) ? "" : "brightness-50 pointer-events-none",
            )}
            onClick={() => onChangeMethod(method.type)}
          >
            {method.icon({ size: 28, className: "text-white" })}
            <div>
              <div className="text-white">{method.title}</div>
              <div className="text-sm">{method.description}</div>
            </div>
          </Button>
        ))}
        <Button type="button" onClick={onSubmit} className="w-full mt-auto">
          Отправить код восстановления
        </Button>
      </div>
    </FocusLock>
  );
}
